import { useEffect, useState } from 'react';

const useFoXPresence = () => {
  const [hasFoXHeadline, setHasFoXHeadline] = useState(false);
  const [hasFoXBreadcrumbs, setHasFoXBreadcrumbs] = useState(false);

  useEffect(() => {
    const checkFoXHeadlinePresence = () => {
      const breadcrumb = document.getElementsByClassName('breadcrumb')[0];
      if (!breadcrumb) return;

      const breadcrumbsItems = breadcrumb.querySelectorAll('.breadcrumb-item')
      const hasBreadcrumbsMinLength = breadcrumbsItems.length > 1

      setHasFoXBreadcrumbs(hasBreadcrumbsMinLength);

      const header = breadcrumb.nextElementSibling;

      const hasCMSHeadline = header?.classList.contains('container-fluid');
      if (hasCMSHeadline) {
        setHasFoXHeadline(true);
      } else {
        setHasFoXHeadline(false);
      }
    };

    checkFoXHeadlinePresence();
  }, []);

  return {
    hasFoXHeadline,
    hasFoXBreadcrumbs
  };
};

export default useFoXPresence;
